import { API_DEFAULT_COLORS, ORGANIZATION_COLORS } from "./constants.js"

export const getOrganizationColorSelectionType = (primary, secondary, accent) => {
  const isDefault =
    primary === API_DEFAULT_COLORS.PRIMARY &&
    secondary === API_DEFAULT_COLORS.SECONDARY &&
    accent === API_DEFAULT_COLORS.ACCENT;

  return isDefault
    ? ORGANIZATION_COLORS.API_CONNECT_DEFAULT
    : ORGANIZATION_COLORS.CUSTOM;
};
